/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Stage_TitleInputs */



/**
* | output |
* | --- |
* | "Stage & OBS Overlay" |
*
* @param {Help_Article_Stage_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_stage_title = /** @type {((inputs?: Help_Article_Stage_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Stage_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stage & OBS-Overlay")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stage et overlay OBS")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("展示台与 OBS 叠加层")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("展示台與 OBS 疊加層")
	if (locale === "ko") return /** @type {LocalizedString} */ ("스테이지와 OBS 오버레이")
	return /** @type {LocalizedString} */ ("Stage & OBS Overlay")
});